/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useEffect,
    useState,
    useRef
} from 'react';
import {
    useHistory,
    Link as RouterLink
} from 'react-router-dom';
import Cookies from 'universal-cookie';
import { Auth } from 'aws-amplify';
import {
    Chip,
    Divider,
    Grid,
    IconButton,
    Link,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid';
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import TlmFilterBar from '../Components/TlmFilterBar.jsx';
import { host, status_severity, FieldSelectLabel, COOKIE_NAMES, useCookiesForData } from "../../data";
import { useTranslation } from 'react-i18next';
import { userSettingsData } from '../../services/userSettingsData';
import { roundToDecimals } from '../../helpers/roundToDecimals.js';

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    content: {
        padding: theme.spacing(2),
    },
    iconButtons: {
        marginRight: theme.spacing(1),
    },
    topMap: {
        width: '100%',
        height: '33vh',
    },
    table: {
        width: '100%',
        height: '70vh',
    },
    link: {
        color: theme.palette.info.dark,
    },
    ok: {
        minWidth: '64px',
        backgroundColor: theme.palette.success.main,
        color: theme.palette.primary.contrastText,
    },
    low: {
        minWidth: '64px',
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.primary.contrastText,
    },
    crit: {
        minWidth: '64px',
        backgroundColor: theme.palette.error.main,
        color: theme.palette.primary.contrastText,
    },
    error: {
        minWidth: '64px',
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.primary.contrastText,
    },
    statusNone: {
        minWidth: '64px',
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
    },
}));

// Branch page component. Display the branch view.
export default function MyTanksPage({ fetchOrgInformation }) {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const [displayUnits, setDisplayUnits] = useState();
    const [csvReportData, setCSVReportData] = useState([])
    const [pdfReportData, setPDFReportData] = useState([]);
    const [pdfReportDataHeaders, setPDFReportDataHeaders] = useState([]);
    const [pdfReportConfigHeaders, setPDFReportConfigHeaders] = useState([]);
    const [csvFileName, setCSVFileName] = useState('reports.csv');
    const [pdfFileName, setPDFFileName] = useState('reports');
    const csvLink = useRef();
    const csvHeaders = [
        { label: t("org"), key: 'OrgName' },
        { label: t("branch"), key: 'BranchName' },
        { label: t("site"), key: 'SiteName' },
        { label: t("tank"), key: 'name' },
        { label: t("status"), key: 'Status' },
        { label: t("fluid"), key: 'fluidName' },
        { label: t("ullage"), key: 'ullage_disp' },
        { label: t("lastReading"), key: 'ReadingTime_CSV' },
        { label: t("city"), key: 'City' },
        { label: t("inventory"), key: 'volume_disp' },
        { label: t("inventoryPercent"), key: 'volume_pct' },
        { label: t("capacity"), key: 'FillCapacity_disp' },
        { label: t("fluidHeight"), key: 'fluid_height_disp' },
        { label: t("nextReading"), key: 'NextReading_CSV' },
        { label: t("dte"), key: 'DTE' },
        { label: t("adu"), key: 'ADU_disp' },
        { label: t("rssi"), key: 'rssi' },
        { label: t("batt"), key: 'batt' },
        { label: t("lastFill"), key: 'FillTime_CSV' },
        { label: t("lastFillV"), key: "FillVolume_disp"},
        { label: t("efficiency"), key: 'Efficiency' },
    ];
    const pdfHeaders = [
        { label: t("org"), key: 'OrgName' },
        { label: t("branch"), key: 'BranchName' },
        { label: t("site"), key: 'SiteName' },
        { label: t("tank"), key: 'name' },
        { label: t("status"), key: 'Status' },
        { label: t("fluid"), key: 'fluidName' },
        { label: t("lastReading"), key: 'ReadingTime_PDF' },
        { label: t("ullage"), key: 'ullage_disp' },
        { label: t("inventory"), key: 'volume_disp' },
        { label: t("dte"), key: 'DTE' },
    ];
    // Default columns for the Branches table.
    const [orgNameColWidth, setOrgNameColWidth] = React.useState(200);
    const [branchNameColWidth, setBranchNameColWidth] = React.useState(200);
    const [siteNameColWidth, setSiteNameColWidth] = React.useState(128);
    const [tankColWidth, setTankColWidth] = React.useState(104);
    const [fluidColWidth, setfluidColWidth] = React.useState(96);
    const [cityColWidth, setCityColWidth] = React.useState(168);
    
    const defaultColumnOrder =[
        'OrgName',
        'BranchName', 
        'SiteName', 
        'name', 
        'Status', 
        'fluidName', 
        'ullage_disp_str',
        'ReadingTime_UTC',
        'City',
        'volume_disp_str',
        'volume_pct',
        'DTE_disp',
        'ADU_disp_str',
        'Efficiency',
        'FillCapacity_disp_str',
        'fluid_height_disp_str',
        'rssi',
        'batt',
        'FillTime',
        'FillVolume_disp_str',
        'NextReading',
    ];
    const [columnOrder, setColumnOrder] = useState([]);
    const [checked2, setChecked2] = useState({
        'OrgName':false, 
        'BranchName':true, 
        'SiteName':true, 
        'name':true, 
        'Status':true, 
        'fluidName':true, 
        'ullage_disp_str':true,
        'ReadingTime_UTC':false,
        'City':false,
        'volume_disp_str':true,
        'volume_pct':false,
        'DTE_disp':false,
        'ADU_disp_str':false,
        'Efficiency':false,
        'FillCapacity_disp_str':false,
        'fluid_height_disp_str':false,
        'rssi':false,
        'batt':false,
        'FillTime':false,
        'FillVolume_disp_str':false,
        'NextReading':false,
    });
    const columnsAlwaysOn = ['name', 'Status'];
    const columnsMyTank = [
        {
            headerName: t("org"),
            field: 'OrgName',
            width: orgNameColWidth,
            //renderCell: renderLink,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("branch"),
            field: 'BranchName',
            width: branchNameColWidth,
            renderCell: renderLink,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("site"),
            field: 'SiteName',
            width: siteNameColWidth,
            renderCell: renderLink,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("tank"),
            field: 'name',
            width: tankColWidth,
            renderCell: renderLink,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("status"),
            field: 'Status',
            width: 104,
            renderCell: renderStatus,
            headerClassName: classes.tableHeader,
            sortComparator: (v1, v2, param1, param2) => param1.row.status_severity - param2.row.status_severity,
            disableClickEventBubbling: true
        },
        {
            headerName: t("fluid"),
            field: 'fluidName',
            width: fluidColWidth,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("ullage"),
            field: 'ullage_disp_str',
            sortComparator: (v1, v2, param1, param2) => param1.row.ullage_disp - param2.row.ullage_disp,
            width: 112,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("lastRead"),
            field: 'ReadingTime_UTC',
            width: 190,
            type: 'dateTime',
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("city"),
            field: 'City',
            width: cityColWidth,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("Inv"),
            description: t("inventory"),
            field: 'volume_disp_str',
            sortComparator: (v1, v2, param1, param2) => param1.row.volume_disp - param2.row.volume_disp,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("InvPercent"),
            description: t("inventory"),
            sortComparator: (v1, v2, param1, param2) => param1.row.volume_pct_int - param2.row.volume_pct_int,
            valueFormatter: (params) => {
                const valueFormatted = params.value === null ? "" : params.value;
                const unit = (params.value === undefined || params.value === null) ? "" : "%"
                return `${valueFormatted}${unit}`;
            },
            field: 'volume_pct',
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("dte"),
            description: t("DaysToEmpty"),
            field: 'DTE_disp',
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("adu"),
            description: t("averageDailyUsage"),
            field: 'ADU_disp_str',
            sortComparator: (v1, v2, param1, param2) => param1.row.ADU_disp - param2.row.ADU_disp,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("fe"),
            field: 'Efficiency',
            description: t("fillEfficiency"),
            valueFormatter: (params) => {
                const valueFormatted = params.value === null ? "" : params.value;
                const unit = (params.value === undefined || params.value === null) ? "" : "%"
                return `${valueFormatted}${unit}`;
            },
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("cap"),
            description: t("capacity"),
            field: 'FillCapacity_disp_str',
            sortComparator: (v1, v2, param1, param2) => param1.row.FillCapacity_disp - param2.row.FillCapacity_disp,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("fluidHt"),
            field: 'fluid_height_disp_str',
            sortComparator: (v1, v2, param1, param2) => param1.row.fluid_height_disp - param2.row.fluid_height_disp,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("rssi"),
            description: t("rfSignalStrength"),
            field: 'rssi',
            valueFormatter: (params) => {
                const valueFormatted = params.value === null ? "" : params.value;
                const unit = (params.value === undefined || params.value === null) ? "" : "%"
                return `${valueFormatted}${unit}`;
            },
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("batt"),
            description: t("battery"),
            field: 'batt',
            valueFormatter: (params) => {
                const valueFormatted = params.value === null ? "" : params.value;
                const unit = (params.value === undefined || params.value === null) ? "" : "%"
                return `${valueFormatted}${unit}`;
            },
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("lastFill"),
            field: 'FillTime',
            type: 'dateTime',
            width: 190,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("fv"),
            description: t("lastFillVolume"),
            field: 'FillVolume_disp_str',
            sortComparator: (v1, v2, param1, param2) => param1.row.FillVolume_sort - param2.row.FillVolume_sort,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
        {
            headerName: t("nextReading"),
            field: 'NextReading',
            type: 'dateTime',
            width: 190,
            headerClassName: classes.tableHeader,
            disableClickEventBubbling: true
        },
    ];
    const handleSetChecked2 = (newChecked) => {
        if (useCookiesForData){
            var cookies = new Cookies();
            cookies.set(COOKIE_NAMES.myTanksColumnsChecked, JSON.stringify(newChecked), { maxAge: 1000000 });
        }
        else {
            updateUserSettingsData(COOKIE_NAMES.myTanksColumnsChecked, JSON.stringify(newChecked));
        }
        setChecked2(newChecked);
    };
    const handleSetColumnOrder = (newOrder) => {
        if (useCookiesForData){
            var cookies = new Cookies();
            cookies.set(COOKIE_NAMES.myTanksColumnsOrder, JSON.stringify(newOrder), { maxAge: 1000000 });
        }
        else {
            updateUserSettingsData(COOKIE_NAMES.myTanksColumnsOrder, JSON.stringify(newOrder));
        }
        setColumnOrder(newOrder);
    };

    React.useEffect(() => {
        var t_tableCols = tableCols;
        for (var i = 0; i < tableCols.length; i++) {
            if (t_tableCols[i].field === "OrgName") {
              t_tableCols[i].width = orgNameColWidth;
            }    
            if (t_tableCols[i].field === "BranchName") {
              t_tableCols[i].width = branchNameColWidth;
            }    
            if (t_tableCols[i].field === "SiteName") {
                t_tableCols[i].width = siteNameColWidth;
            }
            if (t_tableCols[i].field === 'fluidName') {
                t_tableCols[i].width = fluidColWidth;
            }
            if (t_tableCols[i].field === 'name') {
                t_tableCols[i].width = tankColWidth;
            }
            if (t_tableCols[i].field === 'City') {
                t_tableCols[i].width = cityColWidth;
            }
        }
        setTableCols(t_tableCols);
      }, [orgNameColWidth, branchNameColWidth, siteNameColWidth, fluidColWidth, tankColWidth, cityColWidth])

    
    // Create state for the data table.
    const [dataReady, setDataReady] = React.useState(0);
    const [tankInfo, setTankInfo] = React.useState({});
    const [fluids, setFluids] = React.useState([]);
    const [tableCols, setTableCols] = React.useState([]);
    const [tableRows, setTableRows] = React.useState([]);
    const [reportsMenuItems, setReportsMenuItems] = React.useState({});
    const [filtersInfo, setFiltersInfo] = React.useState({ 'fluidName': [], 'statusName': [], 'tagName': [], 'ullageRange': [], 'DTE': "noFilter", 'showSensorWarning': 0});
    const [currentSearchTerm, setCurrentSearchTerm] = React.useState("");

    function createCSVFileName(fileNamePrefix) {
        let d = new Date;
        let dformat = `${("0" + d.getDate()).slice(-2)}${("0" + (d.getMonth() + 1)).slice(-2)}${d.getFullYear()}_${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;

        setCSVFileName(fileNamePrefix + '_' + t("snapshot") + '_' + dformat + '.csv');
        setPDFFileName(fileNamePrefix + '_' + t("snapshot") + '_' + dformat);
    };

    function createCSVData(data_in) {
        var i;
        var k;
        var csvData = [[t("myTanks"), ""]];
        let d = new Date;

        csvData.push([t("dateCreated"), convertDatetoCSVFormat(d)]);
        if (displayUnits.includes("Metric")) {
            csvData.push([t("volumeUnits"), t("liters_caps")]);
            csvData.push([t("dimensionsUnits"), t("centimeters")])
        } else {
            csvData.push([t("volumeUnits"), t("gallons_caps")]);
            csvData.push([t("dimensionsUnits"), t("inches")])
        }

        csvData.push(['']);
        var tempRow = [];
        for (i = 0; i < csvHeaders.length; i++) {
            tempRow.push(csvHeaders[i].label);
        }

        csvData.push(tempRow);
        if (data_in.length > 0) {
            for (k = 0; k < data_in.length; k++) {
                tempRow = []
                for (i = 0; i < csvHeaders.length; i++) {
                    if (data_in[k][csvHeaders[i].key] === null || data_in[k][csvHeaders[i].key] === undefined) {
                        tempRow.push("");
                    }
                    else {
                        tempRow.push(data_in[k][csvHeaders[i].key]);
                    }
                }

                csvData.push(tempRow);
            }
        }

        setCSVReportData(csvData);
    };

    function createPDFData(data_in) {
        var headerArr = [];
        var headerConfigArr = [];
        var bodyArr = [];
        var i;
        var k;
        let d = new Date;

        headerConfigArr.push([t("myTanks"), ""]);
        headerConfigArr.push([t("dateCreated"), d]);

        if (displayUnits.includes("Metric")) {
            headerConfigArr.push([t("volumeUnits"), t("liters_caps")]);
            headerConfigArr.push([t("dimensionsUnits"), t("centimeters")])
        } else {
            headerConfigArr.push([t("volumeUnits"), t("gallons_caps")]);
            headerConfigArr.push([t("dimensionsUnits"), t("inches")])
        }

        setPDFReportConfigHeaders(headerConfigArr);

        if (data_in.length > 0) {
            for (i = 0; i < pdfHeaders.length; i++) {
                headerArr.push(pdfHeaders[i].label);
            }

            for (k = 0; k < data_in.length; k++) {
                var entryArray = [];
                for (i = 0; i < pdfHeaders.length; i++) {
                    if (data_in[k][pdfHeaders[i].key] === null || data_in[k][pdfHeaders[i].key] === undefined) {
                        entryArray.push("");
                    }
                    else {
                        entryArray.push(data_in[k][pdfHeaders[i].key]);
                    }
                }
                bodyArr.push(entryArray);
            }
        }

        setPDFReportDataHeaders([headerArr]);
        setPDFReportData(bodyArr);
    };

    function convertDatetoCSVFormat(inputTimeStamp) {
        //Excel based on 1990.  Java based on 1970.
        //return inputTimeStamp / (1000 * 60 * 60 * 24) + 25569;
        //console.log(inputTimeStamp);
        let ret = inputTimeStamp;
        if (!isNaN(inputTimeStamp.getTime())) {
            ret = inputTimeStamp.toISOString().slice(0, 19).replace('T', ' ').replace(/-/g, '/');
            ret = convertUTCDateToLocalDate(new Date(ret));
        }
        //console.log(ret);
        return ret;
    };

    function convertUTCDateToLocalDate(date) {
        var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();

        newDate.setHours(hours - offset);
        var month = '' + (newDate.getMonth() + 1),
            day = '' + newDate.getDate(),
            year = newDate.getFullYear(),
            hour = newDate.getHours(),
            minute = newDate.getMinutes(),
            second = newDate.getSeconds();

        if (month.length < 2)
            month = '0' + month;

        if (day.length < 2)
            day = '0' + day;

        if (minute < 10)
            minute = '0' + minute;

        if (hour < 10)
            hour = '0' + hour;

        var prettiestStr = month + '/' + day + '/' + year + ' ' + hour + ':' + minute;
        return prettiestStr;
    };

    function calculateStatusSeverity(status, showSensorWarning) {
        var severity = 1;
        if ((typeof status) !== "string") {
            severity = status_severity.unknown;
        }
        else if (status.includes("Comm")) {
            severity = status_severity.Comm;
        }
        else if (status.includes("Batt")) {
            severity = status_severity.Batt;
        }
        else if (status.includes("Crit")) {
            severity = status_severity.Crit;
        }
        else if (status.includes("SensErr")){
            severity = status_severity.SensE;
        }
        else if (status.includes("High")) {
            severity = status_severity.High;
        }
        else if (status.includes("Low")) {
            severity = status_severity.Low;
        }
        else if (status.includes("SensW")  && showSensorWarning) {
            severity = status_severity.SensW;
        }
        else if (status.includes("None")) {
            severity = status_severity.unknown;
        }
        return severity;
    }

    function createTableData(data, showSensorWarning=0) {
        var data_in = data;
        var i;
        const vol_string = displayUnits.includes("US") ? "gal" : "L";
        const dim_string = displayUnits.includes("US") ? "in" : "cm";

        if (displayUnits.includes("Metric")) {

            for (i = 0; i < data_in.length; i++) {
                data_in[i].status_severity = calculateStatusSeverity(data_in[i].Status, showSensorWarning);
                data_in[i].showSensorWarning = showSensorWarning;
                if (!isNaN(data_in[i].fluid_height)) {
                    if (data_in[i].DimensionUnit === 'inches') {
                        data_in[i].fluid_height_disp = Math.round(data_in[i].fluid_height * 2.54);
                    }
                    else if (data_in[i].DimensionUnit === 'feet') {
                        data_in[i].fluid_height_disp = Math.round(data_in[i].fluid_height * 2.54 * 12.0);
                    }
                    else if (data_in[i].DimensionUnit === 'centimeters') {
                        data_in[i].fluid_height_disp = Math.round(data_in[i].fluid_height);
                    }
                }

                if (data_in[i].VolumeUnit === 'gallons') {
                    if (!isNaN(data_in[i].ullage)) {
                        data_in[i].ullage_disp = Math.round(data_in[i].ullage * 3.78541);
                    }
                    if (!isNaN(data_in[i].volume)) {
                        data_in[i].volume_disp = Math.round(data_in[i].volume * 3.78541);
                    }
                    if (!isNaN(data_in[i].FillCapacity)) {
                        data_in[i].FillCapacity_disp = Math.round(data_in[i].FillCapacity * 3.78541);
                    }
                    if (!isNaN(data_in[i].ADU)) {
                        data_in[i].ADU_disp = roundToDecimals(data_in[i].ADU * 3.78541, 2);
                    }
                    if (!isNaN(data_in[i].FillVolume)){
                        data_in[i].FillVolume_disp = Math.round(data_in[i].FillVolume * 3.78541);
                    }
                }
                else if (data_in[i].VolumeUnit === "liters") {
                    if (!isNaN(data_in[i].ullage)) {
                        data_in[i].ullage_disp = Math.round(data_in[i].ullage);
                    }
                    if (!isNaN(data_in[i].volume)) {
                        data_in[i].volume_disp = Math.round(data_in[i].volume);
                    }
                    if (!isNaN(data_in[i].FillCapacity)) {
                        data_in[i].FillCapacity_disp = Math.round(data_in[i].FillCapacity);
                    }
                    if (!isNaN(data_in[i].ADU)) {
                        data_in[i].ADU_disp = roundToDecimals(data_in[i].ADU, 2);                        
                    }
                    if (!isNaN(data_in[i].FillVolume)){
                        data_in[i].FillVolume_disp = Math.round(data_in[i].FillVolume);
                    }
                }

                if (!isNaN(data_in[i].ullage_disp)) {
                    data_in[i].ullage_disp_str = data_in[i].ullage_disp.toFixed(0).toString() + ' ' + vol_string;
                }
                if (!isNaN(data_in[i].volume_disp)) {
                    data_in[i].volume_disp_str = data_in[i].volume_disp.toFixed(0).toString() + ' ' + vol_string;
                }
                if (!isNaN(data_in[i].FillCapacity_disp)) {
                    data_in[i].FillCapacity_disp_str = data_in[i].FillCapacity_disp.toFixed(0).toString() + ' ' + vol_string;
                }
                if (!isNaN(data_in[i].ADU_disp)) {
                    data_in[i].ADU_disp_str = data_in[i].ADU_disp.toFixed(2).toString() + ' ' + vol_string;
                }
                if (!isNaN(data_in[i].fluid_height_disp)) {
                    data_in[i].fluid_height_disp_str = data_in[i].fluid_height_disp.toFixed(0).toString() + ' ' + dim_string;
                }
                if (!isNaN(data_in[i].FillVolume_disp)) {
                    data_in[i].FillVolume_disp_str = data_in[i].FillVolume_disp.toFixed(0).toString() + ' ' + vol_string;
                    data_in[i].FillVolume_sort = data_in[i].FillVolume_disp;
                }
                else {
                    data_in[i].FillVolume_sort = -1;
                }
            }
        }
        else {
            for (i = 0; i < data_in.length; i++) {
                data_in[i].status_severity = calculateStatusSeverity(data_in[i].Status, showSensorWarning);
                data_in[i].showSensorWarning = showSensorWarning;
                if (!isNaN(data_in[i].fluid_height)) {
                    if (data_in[i].DimensionUnit === 'inches') {
                        data_in[i].fluid_height_disp = Math.round(data_in[i].fluid_height);
                    }
                    else if (data_in[i].DimensionUnit === 'feet') {
                        data_in[i].fluid_height_disp = Math.round(data_in[i].fluid_height * 12.0);
                    }
                    else if (data_in[i].DimensionUnit === 'centimeters') {
                        data_in[i].fluid_height_disp = Math.round(data_in[i].fluid_height / 2.54);
                    }
                }

                if (data_in[i].VolumeUnit === 'gallons') {
                    if (!isNaN(data_in[i].ullage)) {
                        data_in[i].ullage_disp = Math.round(data_in[i].ullage);
                    }
                    if (!isNaN(data_in[i].volume)) {
                        data_in[i].volume_disp = Math.round(data_in[i].volume);
                    }
                    if (!isNaN(data_in[i].ADU)) {
                        data_in[i].ADU_disp = roundToDecimals(data_in[i].ADU, 2);
                    }
                    if (!isNaN(data_in[i].FillCapacity)) {
                        data_in[i].FillCapacity_disp = Math.round(data_in[i].FillCapacity);
                    }
                    if (!isNaN(data_in[i].FillVolume)) {
                        data_in[i].FillVolume_disp = Math.round(data_in[i].FillVolume);
                    }
                }
                else if (data_in[i].VolumeUnit === "liters") {
                    if (!isNaN(data_in[i].ullage)) {
                        data_in[i].ullage_disp = Math.round(data_in[i].ullage / 3.78541);
                    }
                    if (!isNaN(data_in[i].volume)) {
                        data_in[i].volume_disp = Math.round(data_in[i].volume / 3.78541);
                    }
                    if (!isNaN(data_in[i].ADU)) {
                        data_in[i].ADU_disp = roundToDecimals(data_in[i].ADU / 3.78541, 2);
                    }
                    if (!isNaN(data_in[i].FillCapacity)) {
                        data_in[i].FillCapacity_disp = Math.round(data_in[i].FillCapacity / 3.78541);
                    }
                    if (!isNaN(data_in[i].FillVolume)) {
                        data_in[i].FillVolume_disp = Math.round(data_in[i].FillVolume) / 3.78541;
                    }
                }

                if (!isNaN(data_in[i].ullage_disp)) {
                    data_in[i].ullage_disp_str = data_in[i].ullage_disp.toFixed(0).toString() + ' ' + vol_string;
                }
                if (!isNaN(data_in[i].volume_disp)) {
                    data_in[i].volume_disp_str = data_in[i].volume_disp.toFixed(0).toString() + ' ' + vol_string;
                }
                if (!isNaN(data_in[i].FillCapacity_disp)) {
                    data_in[i].FillCapacity_disp_str = data_in[i].FillCapacity_disp.toFixed(0).toString() + ' ' + vol_string;
                }
                if (!isNaN(data_in[i].ADU_disp)) {
                    data_in[i].ADU_disp_str = data_in[i].ADU_disp.toFixed(2).toString() + ' ' + vol_string;
                }
                if (!isNaN(data_in[i].fluid_height_disp)) {
                    data_in[i].fluid_height_disp_str = data_in[i].fluid_height_disp.toFixed(0).toString() + ' ' + dim_string;
                }
                if (!isNaN(data_in[i].FillVolume_disp)) {
                    data_in[i].FillVolume_disp_str = data_in[i].FillVolume_disp.toFixed(0).toString() + ' ' + vol_string;
                    data_in[i].FillVolume_sort = data_in[i].FillVolume_disp;
                }
                else {
                    data_in[i].FillVolume_sort = -1;
                }
            }
        }

        return data_in;
    };

    React.useEffect(() => {
        if (tankInfo.json_data !== undefined) {
            FilterData([], false);
        }
    }, [displayUnits, tankInfo, currentSearchTerm]);

    // Setup the data table. Triggers when the site info changes.
    function fetchMyTanksData(){
        var cookies = new Cookies();
        var tFilter = cookies.get(COOKIE_NAMES.branchFilterMyTanks);
        if (undefined !== tFilter) {
            setFiltersInfo(tFilter);
        }
        var tDisplayUnits = cookies.get(COOKIE_NAMES.displayUnits);
        if (undefined !== tDisplayUnits) {
            setDisplayUnits(tDisplayUnits);
        }
        else {
            setDisplayUnits("US");
        }
        if (useCookiesForData){
            var tChecked2 = cookies.get(COOKIE_NAMES.myTanksColumnsChecked);
            if (undefined !== tChecked2){
                setChecked2(tChecked2);
            }
        }

        Auth.currentAuthenticatedUser()
            .then(data => {
                console.log("Fetching branch, site readings...")
                let user = data.attributes.email;
                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    }
                };

                fetch(host + '/mytanks', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        console.log("MyTanks readings fetched.");
                        
                        var Data = data.data;
                        Data.json_data = data.data.json_data.sort((a, b) => (parseFloat(a.ullage_pct) > parseFloat(b.ullage_pct)) ? -1 : ((parseFloat(b.ullage_pct) > parseFloat(a.ullage_pct)) ? 1 : 0));

                        var maxOrgNameLength = 16;
                        var maxBranchNameLength = 16;
                        var maxSiteNameLength = 16;
                        var maxTankNameLength = 13;
                        var maxFluidNameLength = 12;
                        var maxCityNameLength = 16;

                        var f = [];
                        for (var i = 0; i < Data.json_data.length; i++) {
                            try {
                                if (Data.json_data[i].OrgName.length > maxOrgNameLength) {
                                    maxOrgNameLength = Data.json_data[i].OrgName.length;
                                }
                            } catch (error) { }
                            try {
                                if (Data.json_data[i].BranchName.length > maxBranchNameLength) {
                                    maxBranchNameLength = Data.json_data[i].BranchName.length;
                                }
                            } catch (error) { }
                            try {
                                if (Data.json_data[i].SiteName.length > maxSiteNameLength) {
                                    maxSiteNameLength = Data.json_data[i].SiteName.length;
                                }
                            } catch (error) { }
                            try {
                                if (Data.json_data[i].fluidName.length > maxFluidNameLength) {
                                    maxFluidNameLength = Data.json_data[i].fluidName.length;
                                }
                            } catch (error) { }
                            try {
                                if (Data.json_data[i].name.length > maxTankNameLength) {
                                    maxTankNameLength = Data.json_data[i].name.length;
                                }
                            } catch (error) { }
                            try {
                                if (Data.json_data[i].City.length > maxCityNameLength) {
                                    maxCityNameLength = Data.json_data[i].City.length;
                                }
                            } catch (error) { }

                            try {
                                Data.json_data[i].volume_pct_int = parseInt(Data.json_data[i].volume_pct);
                            } catch (error) {
                                Data.json_data[i].volume_pct_int = undefined;
                            }
                            Data.json_data[i].id = [Data.json_data[i].OrgName, Data.json_data[i].BranchName, Data.json_data[i].SiteName, Data.json_data[i].name].join(",");
                            if (Data.json_data[i].ReadingTime === null) {
                                delete Data.json_data[i].ReadingTime_UTC;
                            }
                            Data.json_data[i].ReadingTime_UTC = new Date(Data.json_data[i].ReadingTime_UTC);
                            Data.json_data[i].ReadingTime_CSV = convertDatetoCSVFormat((Data.json_data[i].ReadingTime_UTC));
                            Data.json_data[i].ReadingTime_PDF = Data.json_data[i].ReadingTime_UTC.toLocaleString();
                            Data.json_data[i].NextReading_CSV = "";

                            if (Data.json_data[i].NextReading) {
                                Data.json_data[i].NextReading = new Date(Data.json_data[i].NextReading);
                                Data.json_data[i].NextReading_CSV = convertDatetoCSVFormat((Data.json_data[i].NextReading));
                            }

                            Data.json_data[i].FillTime_CSV = ""
                            if (Data.json_data[i].FillTime) {
                                Data.json_data[i].FillTime = new Date(Data.json_data[i].FillTime);
                                Data.json_data[i].FillTime_CSV = convertDatetoCSVFormat(Data.json_data[i].FillTime);
                            }

                            Data.json_data[i].ullage = parseFloat(Data.json_data[i].ullage);
                            Data.json_data[i].volume = parseFloat(Data.json_data[i].volume);
                            Data.json_data[i].FillCapacity = parseFloat(Data.json_data[i].FillCapacity);
                            Data.json_data[i].FillVolume = parseFloat(Data.json_data[i].FillVolume);
                            Data.json_data[i].ADU = parseFloat(Data.json_data[i].ADU);
                            Data.json_data[i].fluid_height = parseFloat(Data.json_data[i].fluid_height);
                            if (Data.json_data[i].DTE !== undefined && Data.json_data[i].DTE !== null) {
                                Data.json_data[i].DTE_disp = parseFloat(Data.json_data[i].DTE);
                            }
                            if ((typeof Data.json_data[i].Status) !== "string") {
                                Data.json_data[i].Status = "None";
                            }
                            Data.json_data[i].status_severity = calculateStatusSeverity(Data.json_data[i].Status, 0);
                        }

                        for (var i = 0; i < Data.fluidsList.length; i++) {
                            f.push({ 'id': i, 'name': Data.fluidsList[i] })
                        }

                        setOrgNameColWidth(maxOrgNameLength*9);
                        setBranchNameColWidth(maxBranchNameLength*9 + 8);
                        setSiteNameColWidth(maxSiteNameLength*9 + 8);
                        setfluidColWidth(maxFluidNameLength*9 + 8);
                        setTankColWidth(maxTankNameLength*9 + 8);
                        setCityColWidth(maxCityNameLength*9 + 8);
                        setFluids(f);
                        setTankInfo(Data);
                        setDataReady(1);
                        createCSVFileName("MyTanks");
                    }).catch((error) => {
                        console.log(error);
                    });
            })
    }

    async function fetchUserSettingsData(){
        try {
            let tempOrder = [];
            var i;
            var tempUpdates = {};
            
            const { status, data } = await userSettingsData.getUserSettingsData();

            const error = data.error;
            const settingsData = data.data;
            
            if (status === 404) {
                console.log("fetchUserSettingsData 404");
            }

            if (error !== 'OK' && status !== 200) {
                alert(t("sorryUnableToRetrieve"));
                throw new Error(error);
            }

            //console.log(settingsData);
            var cookies = new Cookies();
            //Code to check for cookies and use existing cookies (update)
            if (settingsData[COOKIE_NAMES.myTanksColumnsOrder]) {
                setColumnOrder(JSON.parse(settingsData[COOKIE_NAMES.myTanksColumnsOrder]));
            }
            else if (cookies.get(COOKIE_NAMES.myTanksColumnsOrder)) {
                //Use and remove cookie
                console.log("Cookies Detected for Column Order");
                var tColumnOrder = cookies.get(COOKIE_NAMES.myTanksColumnsOrder);

                if (undefined !== tColumnOrder){
                    setColumnOrder(tColumnOrder);
                }
                else {
                    defaultColumnOrder.forEach(function(value, index) {
                        for(i=0; i < columnsMyTank.length; i++){
                            if (columnsMyTank[i].field === value){
                                tempOrder.push({key:value, label: FieldSelectLabel[value]});
                                break;
                            }
                        }
                    });
                }
                tempUpdates[COOKIE_NAMES.myTanksColumnsOrder] = JSON.stringify(tColumnOrder);
            }
            else {
                //Defaults
                console.log("Load Default Column Order");
                defaultColumnOrder.forEach(function(value, index) {
                    for(i=0; i < columnsMyTank.length; i++){
                        if (columnsMyTank[i].field === value){
                            tempOrder.push({key:value, label: FieldSelectLabel[value]});
                            break;
                        }
                    }
                });
                setColumnOrder(tempOrder);
            }

            //Checked Columns
            if (settingsData[COOKIE_NAMES.myTanksColumnsChecked]){
                setChecked2(JSON.parse(settingsData[COOKIE_NAMES.myTanksColumnsChecked]))
            }
            else if(cookies.get(COOKIE_NAMES.myTanksColumnsChecked)){
                console.log("Cookies Detected for columns checked");
                var tChecked2 = cookies.get(COOKIE_NAMES.myTanksColumnsChecked);
                if (undefined !== tChecked2){
                    setChecked2(tChecked2);
                }
                tempUpdates[COOKIE_NAMES.myTanksColumnsChecked] = JSON.stringify(tChecked2);
            }
            else {
                //Default
            }
            
            if(Object.keys(tempUpdates).length){
                const { status, data } = await userSettingsData.updateUserSettingsData(tempUpdates);
                if (status === 200) {
                    console.log("Removing old cookies");
                    cookies.remove(COOKIE_NAMES.myTanksColumnsOrder);
                    cookies.remove(COOKIE_NAMES.myTanksColumnsChecked);
                }
                else {
                    console.log("Failed to update back-end with cookie data")
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function updateUserSettingsData(settingsName, settingsDataIn){
        const lsettingsName = settingsName;
        const lsettingsDataIn = settingsDataIn;
        try {
            var updateData;
            
            updateData = userSettingsData.formatSettings(lsettingsName, lsettingsDataIn);
            const { status, data } = await userSettingsData.updateUserSettingsData(updateData);
            const { error } = data;
            const settingsData = data.data;

            if (status === 404) {
                console.log("updateUserSettingsData 404");
            }

            if (error !== 'OK' && status !== 200) {
                alert(t("sorryUnableToRetrieve"));
                throw new Error(error);
            }

            //console.log(settingsData);
            
        } catch (error) {
            console.error(error);
        }
    }

    React.useEffect(() => {
        if (!useCookiesForData){
            fetchUserSettingsData();
        }
        fetchMyTanksData();
    }, []);

    // Update the table column display. Triggers when the column list changes.
    useEffect(() => {
        let newColumns = [];
        var i, k;
        if (columnOrder.length){
            columnOrder.forEach(function (item, index) {
                for (i=0; i < columnsMyTank.length; i++){
                    if (columnsMyTank[i].field === item.key){
                        if (checked2[item.key]){
                            newColumns.push(columnsMyTank[i]);
                        }
                        break;
                    }
                }
            });
            setTableCols(newColumns);
        }
    }, [checked2, columnOrder]);

    useEffect(() => {
        let tempOrder = []
        var cookies = new Cookies();
        var i;
        
        if (columnOrder.length == 0 && useCookiesForData){
            var tColumnOrder = cookies.get(COOKIE_NAMES.myTanksColumnsOrder);
            if (undefined !== tColumnOrder){
                setColumnOrder(tColumnOrder);
            }
            else {
                defaultColumnOrder.forEach(function(value, index) {
                for(i=0; i < columnsMyTank.length; i++){
                    if (columnsMyTank[i].field === value){
                        tempOrder.push({key:value, label: FieldSelectLabel[value]});
                        break;
                    }
                }
                });
                setColumnOrder(tempOrder);
            }
        }
    }, []);

    

    function updateDisplayUnits(input_units) {
        var cookies = new Cookies();
        cookies.set(COOKIE_NAMES.displayUnits, input_units, { path: "/", maxAge: 1000000 });
        setDisplayUnits(input_units);
    }
    // Render functions to help properly render the table.
    const handleClickLink = (params) => {
        const orgName = (params.row.id.split(","))[0];
        const branchName = (params.row.id.split(","))[1];
        fetchOrgInformation(orgName, false);
        let url = params.field === 'OrgName' ? '/orgs/' + orgName : (params.field === 'BranchName' ? '/orgs/' + orgName + '/branches/' + branchName : (params.field === 'SiteName'
            ? '/orgs/' + orgName + '/branches/' + branchName + '/sites/' + params.value
            : '/orgs/' + orgName + '/branches/' + branchName + '/sites/' + params.getValue('SiteName') + '/tanks/' + params.value));
        history.push(url);
    };

    function renderLink(params) {
        return (
            <Link href="#" className={classes.link}
                onClick={() => handleClickLink(params)}>
                {params.value}
            </Link>
        );
    };

    function renderStatus(params) {
        var status = params.value;
        var status_key = "ok"
        var status_disp = t("ok");

        if ((typeof status) !== "string") {
            status_disp = "";
            status_key = "";
        }
        else if (status.includes("Comm")) {
            status_disp = t("comm");
            status_key = "comm";
        }
        else if (status.includes("SensErr")){
            status_disp = t("senserr");
            status_key = "sensorError";
        }
        else if (status.includes("Crit")) {
            status_disp = t("crit");
            status_key = "crit";
        }
        else if (status.includes("Batt")) {
            status_disp = t("batt");
            status_key = "batt";
        }
        else if (status.includes("High")) {
            status_disp = t("high");
            status_key = "high";
        }
        else if (status.includes("Low")) {
            status_disp = t("low");
            status_key = "low";
        }
        else if (status.includes("SensW") && params.row.showSensorWarning){
            status_disp = t("sensw");
            status_key = "sensorWarning"
        }
        else if (status.includes("None")) {
            status_disp = t("none");
            status_key = "none"
        }
        var param_display = "";
        if (status !== undefined) {
            var param_display_list = status.toLowerCase().split(",");
            for (var i = 0; i < param_display_list.length; i++) {
                param_display_list[i] = t(param_display_list[i]);
            }
            param_display = param_display_list.join(",");
        }
        return (
            <Tooltip title={params.value !== undefined ? param_display : ""}>
                <Chip label={status_disp} size="small"
                    className={status_key === "ok"
                        ? classes.ok
                        : status_key === "low"
                            ? classes.low
                            : status_key === "high"
                                ? classes.low
                                : status_key === "crit"
                                    ? classes.crit
                                    : status_key === "sensorWarning"
                                    ? classes.low
                                        : status_key === "none" ? classes.statusNone : classes.error} />
            </Tooltip>
        );
    }

    function FilterData(filterData, update = false) {
        var addItem = false;
        var newData = [];
        var tstatus = [];
        var ullage_pct = 0;
        var filters = {};
        var data_DTE = 0;
        if (update) {
            var cookies = new Cookies();
            setFiltersInfo(filterData);
            cookies.set(COOKIE_NAMES.branchFilterMyTanks, JSON.stringify(filterData), {path: "/", maxAge: 1000000 });
            filters = filterData;
        }
        else {
            filters = filtersInfo;
        }

        for (var i = 0; i < tankInfo.json_data.length; i++) {
            addItem = true;
            if (filters.fluidName.length && addItem) {
                for (var j = 0; j < filters.fluidName.length; j++) {
                    if (-1 == filters.fluidName[j].indexOf(tankInfo.json_data[i].fluidName)) {
                        addItem = false;
                    }
                    else {
                        addItem = true;
                        break;
                    }
                }
            }
            if (filters.tagName.length && addItem) {
                addItem = false;
                if ('Tags' in tankInfo.json_data[i]) {
                    for (var j = 0; j < tankInfo.json_data[i].Tags.length; j++) {
                        for (var k = 0; k < filters.tagName.length; k++) {
                            if (-1 !== filters.tagName[k].indexOf(tankInfo.json_data[i].Tags[j])) {
                                addItem = true;
                                break;
                            }
                        }
                        if (addItem) { break; }
                    }
                }
            }
            if (filters.statusName.length && addItem) {
                tstatus = tankInfo.json_data[i].Status.split(",");
                addItem = false;
                for (var j = 0; j < tstatus.length; j++) {
                    for (var k = 0; k < filters.statusName.length; k++) {
                        if (-1 !== filters.statusName[k].indexOf(tstatus[j])) {
                            addItem = true;
                            break;
                        }
                    }
                    if (addItem) { break; }
                }
            }
            if (filters.DTE && (filters.DTE !== "noFilter") && addItem) {
                data_DTE = (tankInfo.json_data[i].DTE);
                //console.log(data_DTE);
                if (data_DTE >= parseFloat(filters.DTE) || null === data_DTE || undefined === data_DTE) {
                    addItem = false;
                }
            }
            if ((filters.ullageRange[0] > 0 || filters.ullageRange[1] < 100) && (filters.ullageRange.length !== 0) && addItem) {
                ullage_pct = parseFloat(tankInfo.json_data[i].ullage_pct);
                if (ullage_pct < filters.ullageRange[0] || ullage_pct > filters.ullageRange[1]) {
                    addItem = false;
                }
            }
            if (currentSearchTerm){
                if(tankInfo.json_data[i].name){
                    let tankName = tankInfo.json_data[i].name.toUpperCase();
                    let lSearchTerm = currentSearchTerm.toUpperCase();
                    if(!tankName.includes(lSearchTerm)){
                        addItem = false;
                    }
                }
                else{
                    addItem = false;
                }
            }
            if (addItem) {
                newData.push(tankInfo.json_data[i]);
            }
            else {
                console.log(tankInfo.json_data[i]);
            }
        }
        
        createCSVFileName("MyTanks");
        newData = createTableData(newData, filters.showSensorWarning);
        setTableRows(newData);
        createCSVData(newData);
        createPDFData(newData);
    };

    const downloadCSVReport = (event) => {
        console.log("Downloading CSV for branch data...");
        csvLink.current.link.click();
    };

    const downloadPDFReport = (event) => {
        console.log("Downloading PDF for branch data...");

        const pdf = new jsPDF('l', 'pt', 'a4');

        pdf.autoTable({ html: '#report-data-table' });
        pdf.autoTable({
            body: pdfReportConfigHeaders,
        });

        pdf.autoTable({ html: '#report-table' });
        pdf.autoTable({
            head: pdfReportDataHeaders,
            body: pdfReportData,
        });

        pdf.save(pdfFileName);
    };

    // TODO: POST data to API to schedule a report
    const scheduleRecurringReport = async (event) => {
        // try {
        //     let user = Auth.currentAuthenticatedUser();
        //     user.getSession((err, session) => {
        //         if (err) {
        //             console.log(err);
        //             return;
        //         }

        //         const sessionToken = session.getIdToken().jwtToken;

        //         var body = JSON.stringify(
        //             {
        //                 "Name": 'test',
        //             }
        //         );

        //         var requestOptions = {
        //             method: 'POST',
        //             headers: {
        //                 'Content-Type': 'application/json',
        //                 'Authorization': sessionToken
        //             },
        //             body: body
        //         };

        //         let orgId = 1;
        //         let branchId = 2;

        //         fetch(host + '/orgs/' + orgId + '/branches/' + branchId + '/reports', requestOptions)
        //             .then(response => {
        //                 console.log(response);
        //             });
        //     });
        // } catch (e) {
        //     console.log(e);
        // };
    };

    // TODO: GET data to API to schedule a report
    const getUserRecurringReportRequest = (event) => {
        // Auth.currentAuthenticatedUser()
        // .then(data => {
        //     console.log("Fetching branch, user reports schedule...")

        //     var requestOptions = {
        //         method: 'GET',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             'Authorization': data.signInUserSession.idToken.jwtToken
        //         }
        //     };

        //     let orgId = 1;
        //     let branchId = 2;

        //     fetch(host + '/orgs/' + orgId + '/branches/' + branchId + '/reports', requestOptions)
        //         .then(results => results.json())
        //         .then(data => {
        //             console.log(data);
        //         }).catch((error) => {
        //             console.log(error);
        //         });
        // })
    };

    const deleteRecurrSchedule = async (event) => {
        // let user = await Auth.currentAuthenticatedUser()
        //     .then(data => {
        //         console.log("Deleting branch, user reports schedule...")

        //         var requestOptions = {
        //             method: 'DELETE',
        //             headers: {
        //                 'Content-Type': 'application/json',
        //                 'Authorization': data.signInUserSession.idToken.jwtToken
        //             }
        //         };

        //         fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/reports', requestOptions)
        //             .then(results => results.json())
        //             .then(data => {
        //                 console.log(data);
        //             }).catch((error) => {
        //                 console.log(error);
        //             });
        //     });
    };

    if (!dataReady) {
        return (<div>
            <Typography align="center">{t("loadingData")}</Typography>
        </div>)
    }

    return (
        <Grid container
            direction="row"
            justify="center"
            alignItems="stretch"
            className={classes.content}>

            <CSVLink
                data={csvReportData}
                filename={csvFileName}
                className='hidden'
                ref={csvLink}
                target='_blank' />

            <Grid item xs>
                <Grid container
                    direction='column'
                    justify='flex-start'
                    alignItems='stretch'
                    spacing={0}>
                    <Grid item xs>
                        <Toolbar>
                            <Tooltip title={t("goHome")}>
                                <IconButton color='primary'
                                    component={RouterLink}
                                    to={'/'}>
                                    <ArrowBack />
                                </IconButton>
                            </Tooltip>
                            <Typography variant='h5' color='textPrimary'>{t("myTanks")}</Typography>
                        </Toolbar>
                    </Grid>
                    <Divider />
                    <Grid item xs>
                        <TlmFilterBar 
                            showRefresh={true}
                            refreshFunction={fetchMyTanksData}
                            tags={tankInfo.tagsList}
                            fluids={fluids}
                            columnOrder={columnOrder} checked2={checked2} setChecked2={handleSetChecked2} setOrder={handleSetColumnOrder}
                            disableColumns={columnsAlwaysOn}
                            setFilters={FilterData}
                            filtersInfo={filtersInfo}
                            currentSearchTerm={currentSearchTerm}
                            handleSearchTerm={(value) => {setCurrentSearchTerm(value);}}
                            displayUnits={displayUnits}
                            setDisplayUnits={updateDisplayUnits}
                            onCSVDownloadRequest={downloadCSVReport}
                            onPDFDownloadRequest={downloadPDFReport}
                            disableScheduleReport={true}
                            onRecurringReportRequest={scheduleRecurringReport}
                            onGetUserRecurringReportRequest={getUserRecurringReportRequest}
                            deleteRecurrentReportRequest={deleteRecurrSchedule}
                            reportingMenuItems={reportsMenuItems} />
                    </Grid>
                    <Grid item xs>
                        <div className={classes.table}>
                            <DataGrid hideFooterSelectedRowCount
                                rowsPerPageOptions={[25, 50, 100]}
                                pagination
                                pageSize={100}
                                rows={tableRows}
                                columns={tableCols} />
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
